module.exports = __webpack_public_path__ + "img/live-scan.d8fa2c48.jpg";